import React, { Component } from 'react';

import 'bootstrap'

export default class Modal extends Component{

    onCloseModal = (e) => {
        e.preventDefault();
        
        if(this.props.hasOwnProperty('onCloseFn')){
            this.props.onCloseFn(e);
        }
    }

    render(){
        const { 
            title,
            children,
            closable,
            className
        } = this.props

        return(
            <div className="clearfix">
                <div
                    className={ "modal modal-danger " + className }
                    tabIndex="-1" 
                    role="dialog"
                    id="modal"
                    ref="modal">

                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                {
                                    closable === true ?
                                        <button 
                                            type="button" 
                                            className="close" 
                                            data-dismiss="modal" 
                                            aria-label="Close"
                                            onClick={ this.onCloseModal }>

                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    :
                                        null
                                }
                                <h4 className="modal-title">{ title }</h4>
                            </div>
                            <div className="modal-body clearfix">{ children }</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }  
}


// WEBPACK FOOTER //
// ./src/components/Modal.jsx